"use client";

import Link from "next/link";

const NAV_LINKS = [
  { label: "How It Works", href: "/#how-it-works" },
  { label: "Features", href: "/features" },
  { label: "Pricing", href: "/pricing" },
  { label: "Blog", href: "/blog" },
  { label: "Contact", href: "/contact" },
];

interface NavLinksProps {
  className?: string;
  onClick?: () => void;
}

export function NavLinks({ className = "", onClick }: NavLinksProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    if (href.startsWith("/#")) {
      const id = href.replace("/#", "#");
      const element = document.querySelector(id);
      if (element) {
        e.preventDefault();
        element.scrollIntoView({ behavior: "smooth" });
        window.history.pushState(null, "", href);
      }
    }
    onClick?.();
  };

  return (
    <nav className={className} aria-label="Main navigation">
      {NAV_LINKS.map((link) => (
        <Link
          key={link.label}
          href={link.href}
          onClick={(e) => handleClick(e, link.href)}
          className="text-xs transition-colors duration-200 cursor-pointer tracking-widest uppercase py-2"
          style={{ color: "rgba(245,240,232,0.45)", fontFamily: "'Montserrat', sans-serif", borderBottom: onClick ? "1px solid rgba(201,168,76,0.06)" : undefined }}
          onMouseEnter={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = "rgba(201,168,76,0.8)"; }}
          onMouseLeave={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = "rgba(245,240,232,0.45)"; }}
        >
          {link.label}
        </Link>
      ))}
    </nav>
  );
}
